export default __webpack_public_path__ + "34726db6e7803bf094634466b78c623a.png";